import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { Heading, Button, Input } from '@/components/lib'
import api from '../../api'
import utils from '../../utils/utils'

import EntryContainer from '../includes/EntryContainer'

export default function ResetPassword () {
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  function resetPassword () {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    setLoading(true)
    api.accounts.updatePasswordWithToken(token, password, () => {
      setLoading(false)
      utils.toast('success', 'Password set successfully.')
      navigate('/')
    }, (err) => {
      setLoading(false)
      utils.toast('error', 'Unable to reset password', err.message)
    })
  }

  return (
    <EntryContainer>
      <Heading size='lg' mb={5}>Reset password</Heading>
      <Heading size='sm' mb={4}>Enter a new password for your account below.</Heading>
      <Input placeholder='Type a password...' size='lg' type='password' value={password} onChange={e => setPassword(e.target.value)} autoFocus />
      <Button isLoading={loading} mt={5} colorPalette='primary' onClick={resetPassword}>Set Password</Button>
    </EntryContainer>
  )
}
